export const vendureConfig = `
import { AdminUiPlugin } from '@vendure/admin-ui-plugin'
import { AssetServerPlugin } from '@vendure/asset-server-plugin'
import {
  DefaultJobQueuePlugin,
  DefaultSearchPlugin,
  DefaultSchedulerPlugin,
  VendureConfig,
  dummyPaymentHandler,
} from '@vendure/core'
import {
  EmailPlugin,
  FileBasedTemplateLoader,
  defaultEmailHandlers,
} from '@vendure/email-plugin'
import { HardenPlugin } from '@vendure/harden-plugin'
import { GraphiqlPlugin } from '@vendure/graphiql-plugin'
import path from 'path'

const IS_DEV = process.env.NODE_ENV === 'development'
const serverPort = +process.env.PORT || 3000

export const config: VendureConfig = {
  apiOptions: {
    port: serverPort,
    adminApiPath: 'admin-api',
    shopApiPath: 'shop-api',
    introspection: IS_DEV,
    playground: IS_DEV,
  },
  authOptions: {
    tokenMethod: ['bearer', 'cookie'],
    superadminCredentials: {
      identifier: process.env.SUPERADMIN_USERNAME || 'superadmin',
      password: process.env.SUPERADMIN_PASSWORD || 'superadmin',
    },
    cookieOptions: {
      secret: process.env.COOKIE_SECRET || 'cookie-secret',
    },
    requireVerification: false,
  },
  dbConnectionOptions: {
    type: 'better-sqlite3',
    database: path.join(__dirname, '../vendure.sqlite'),
    synchronize: false,
    logging: false,
  },
  paymentOptions: {
    paymentMethodHandlers: [dummyPaymentHandler],
  },
  customFields: {
    Product: [
      {
        name: 'downloadable',
        type: 'boolean',
        defaultValue: false,
      },
      {
        name: 'downloadUrl',
        type: 'string',
        nullable: true,
      },
    ],
    ProductVariant: [
      {
        name: 'weight',
        type: 'float',
        nullable: true,
      },
    ],
    Customer: [
      {
        name: 'loyaltyPoints',
        type: 'int',
        defaultValue: 0,
      },
    ],
    Order: [
      {
        name: 'giftMessage',
        type: 'text',
        nullable: true,
      },
    ],
  },
  plugins: [
    AssetServerPlugin.init({
      route: 'assets',
      assetUploadDir: path.join(__dirname, '../static/assets'),
      assetUrlPrefix: IS_DEV ? undefined : 'https://demo.vendure.io/assets/',
    }),
    DefaultJobQueuePlugin.init({ useDatabaseForBuffer: true }),
    DefaultSearchPlugin.init({ bufferUpdates: false, indexStockStatus: true }),
    DefaultSchedulerPlugin.init(),
    EmailPlugin.init({
      devMode: true,
      outputPath: path.join(__dirname, '../static/email/test-emails'),
      route: 'mailbox',
      handlers: defaultEmailHandlers,
      templateLoader: new FileBasedTemplateLoader(
        path.join(__dirname, '../static/email/templates'),
      ),
      globalTemplateVars: {
        fromAddress: '"Vendure Demo Store" <noreply@vendure.io>',
        verifyEmailAddressUrl: 'http://localhost:8080/verify',
        passwordResetUrl: 'http://localhost:8080/password-reset',
        changeEmailAddressUrl: 'http://localhost:8080/verify-email-address-change',
      },
    }),
    AdminUiPlugin.init({
      route: 'admin',
      port: serverPort + 2,
      adminUiConfig: {
        apiPort: serverPort,
      },
    }),
    HardenPlugin.init({
      maxQueryComplexity: 10000,
      queryComplexityEstimation: true,
      enableGraphiQLInProduction: false,
    }),
    GraphiqlPlugin.init({
      enabled: IS_DEV,
    }),
  ],
}
`
